import { lazy } from 'react';

const DocumentUploadRoute = lazy(() => import('../components/steps/documents-step/DocumentUpload'));

export default DocumentUploadRoute;
